import { Text, useToast } from '@chakra-ui/react'
import React, { useEffect, useMemo, useRef, useState } from 'react'
// import { errorHandle } from '../../api/api'
import { getAllOwnerQueues, patchUpdateDisclaimQueue } from '../../classes/Queue'
import { useUserContext } from '../../context/userContext'
import { BadgeQueueStatus, Table } from '../shared'
import TableButtonDisclaimQueue from '../shared/TableButtonDisclaimQueue'
import SelectedItemAlertContext, { defaultSelectData } from '../../context/selectedItemAlertContext'
import DialogConfirm from '../shared/DialogConfirm'
import { toastErrDesc, toastVal } from '../../utils/toastUtils'

const TableUserQueues = () => {
    const { userData } = useUserContext()
    const [itemData, setItemData] = useState(defaultSelectData)
    const toast = useToast()

    const columns = useMemo(() => {
        const cols = [
            {
                Header: 'อาคาร',
                accessor: 'residence_name'
            },
            {
                Header: 'ลำดับคิว',
                accessor: 'order',
                Cell: ({ value }) => <Text fontWeight="bold">{value}</Text>
            },
            {
                Header: 'วันที่ยื่น',
                accessor: 'submit_date',
            },
            {
                Header: 'ยื่นเวลา',
                accessor: 'submit_time',
            },
            {
                Header: 'สถานะ',
                accessor: 'queue_status_id',
                Cell: ({ value }) => (<BadgeQueueStatus status={value} />)
            },
            {
                Header: 'วันนัด',
                accessor: 'appointment_date',
            },
            {
                Header: 'สถานที่',
                accessor: 'appointment_location',
            },
            {
                Header: 'สละสิทธิ',
                Cell: ({ row }) => (<TableButtonDisclaimQueue row={row} />)
            },
        ]

        return cols
    }
        , [])
    const [data, setData] = useState(null) // list record of queues

    const loadData = useRef()
    loadData.current = async () => {
        await getAllOwnerQueues(userData.id, userData.token)
            .then(res => {
                setData(res)
            })
            .catch(error => {
                // console.log('error')
                // console.log(errorHandle(error))
                toast(toastVal({
                    title: "การดึงข้อมูล ไม่สำเร็จ",
                    description: toastErrDesc(error),
                    status: "error",
                }))
            })

    }

    useEffect(() => {
        loadData.current()
    }, [])

    const disclaimQueueHandle = async (qid) => {
        await patchUpdateDisclaimQueue(qid, userData.token)
            .then(res => {
                loadData.current()
                toast(toastVal({
                    title: "ดำเนินการสละสิทธิคิว สำเร็จ",
                    description: `สละสิทธิคิว เรียบร้อยแล้ว`,
                }))
            })
            .catch(error => {
                toast(toastVal({
                    title: "ดำเนินการสละสิทธิคิว ไม่สำเร็จ",
                    description: toastErrDesc(error),
                    status: "error",
                }))
            })
    }

    return (
        <SelectedItemAlertContext.Provider value={[itemData, setItemData]} >
            {data && <Table columns={columns} data={data} />}
            <DialogConfirm data={itemData} deleteHandle={disclaimQueueHandle} />
        </SelectedItemAlertContext.Provider>

    )
}

export default TableUserQueues
